var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusMeta)?_c('el-tag',{style:({
    backgroundColor: _vm.statusMeta.color,
    borderColor: _vm.statusMeta.color,
    color: _vm.statusMeta.textColor,
    borderRadius: '8px',
  })},[_vm._v("\n  "+_vm._s(_vm.statusMeta.label)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }